export default __webpack_public_path__ + "adobe-premiere-pro.1de4e0cf.png";